define("StoreLocator.Map.View.Extension", [
    "StoreLocator.Map.View",
    "Ames.StoreLocator2.StoreLocator2.Model",
  ], function (StoreLocatorMapView, StoreLocator2Model) {
    "use strict";
  
    _.extend(StoreLocatorMapView.prototype, {
      updateMap: _.wrap(StoreLocatorMapView.prototype.updateMap, function (fn) {
        // keep original init
        var self = this;
        self.locatorModel = new StoreLocator2Model();
        
        if (jQuery(".store-locator-search-button-find").length === 0) {
          self.locatorModel
            .fetch({ data: { locationId: "all" } })
            .done(function (resp) {
              var raw = localStorage.getItem("locationSelected");
              // add store hours to the model
              _.map(self.collection.models, function (model) {
                var loc = _.find(resp.locations, { id: model.id });
                if (loc) {
                  model.set("storeHours", loc.storeHours);
                }
              });

              if (!raw || JSON.parse(raw).length === 0) {
                // get the first 3 locations
                if (self.collection.length) {
                  
                  self.reference_map.showPointList(self.collection, self.map);
                  self.reference_map.fitBounds(self.map);
                  self.collection.models = self.collection.models.slice(0, 3);
                  self.collection.length = 3;
                }
              } else {
                self.optionsSelected = JSON.parse(raw);
  
                // static copy of original models
                var originals = self.collection.models.slice();
                var matched = [];
                var locations = resp.locations || [];
  
                // filter by shopType or extraTypes
                originals.forEach(function (model) {
                  var loc = _.findWhere(locations, { id: model.id });
                  if (!loc) return;
                  var shopOK = self.optionsSelected.indexOf(loc.shopType) !== -1;
                  // var extras = loc.extraTypes ? loc.extraTypes.split(',') : [];
                  // trim and split extraTypes string into array
                  var extras = loc.extraTypes
                    ? loc.extraTypes.split(",").map(function (t) {
                        return t.trim();
                      })
                    : [];
                  // check if any extra type is selected
                  var extraOK = extras.some(function (type) {
                    return self.optionsSelected.indexOf(parseFloat(type)) != -1;
                  });
                  if (shopOK || extraOK) {
                    matched.push(model);
                  }
                });
  
                // limit to first 3 and update collection
                var toShow = matched.slice(0, 3);
                if (self.collection.length) {
                  self.reference_map.clearPointList(this.map);
                  if (toShow.length > 0) {
                    self.collection.models = toShow;
                    self.collection.length = toShow.length;
                    self.reference_map.showPointList(self.collection, self.map);
                    self.reference_map.fitBounds(self.map);
                  }
                }
                // if (toShow.length === 0 && self.optionsSelected.length > 0) {
                //   setTimeout(function () {
                //     $(".store-locator-results-list").hide();
                //     $(".store-locator-results-nav-description-highlight").text(
                //       "No results found"
                //     );
                //   }, 1000);
                // } else if (toShow.length === 0 && originals.length > 0) {
                //   self.collection.models = originals.slice(0, 3);
                //   self.collection.length = 3;
                // } else {
                //   self.collection.models = toShow;
                //   self.collection.length = toShow.length;
                // }
              }
              
              var position = self.reference_map.getPosition();
  
              if (position && _.size(position) && !position.refineSearch) {
                  self.reference_map.showMyPosition(position, self.map);
              } else {
                  self.reference_map.centerMapToDefault(self.map);
              }
              // fn.apply(self, Array.prototype.slice.call(arguments, 1));
            });
        }
      }),
    });
  });
  
